import
  React, {
    useEffect,
    useState,
    createRef,
    Fragment,
} from 'react';

import { connect } from 'react-redux';

import { Creators as ChatCreators } from 'store/ducks/chat';
import { Creators as TaskCreators } from 'store/ducks/task';

import moment from 'moment';
import _ from 'lodash';

import Modal from 'components/Modal';

import hireChatIcon from 'assets/img/icons/hire-chat-button.svg';
import detailsChatIcon from 'assets/img/icons/details-chat-button.svg';
import paperAirplaneIcon from 'assets/img/icons/paper-airplane.svg';
import starIcon from 'assets/img/icons/star.svg'

import { hidePhoneNumber, hasBlockedContent } from 'utils/chatValidation';
import HireModal from '../../OrderModals/HireModal';
import DetailsModal from '../../OrderModals/DetailsModal';
import RatingsModal from '../../OrderModals/RatingsModal'

import Message from './Message';

import { BlockedModal, NewAmountModal } from './SystemMessagesModal';

import {
  ChatColumnCard,
  TopBar,
  Button,
  MessagesArea,
  MessageList,
  SendBar,
  InputMessage,
  SendButton,
  Icon,
  TypingIndicator,
  Date,
} from './styles';

const viewRef = createRef();

const ChatColumn = ({
  taskQuoteProDetail,
  taskDetail,
  chat,
  triiderUser,
  _readMessages,
  _sendMessage,
  _startTyping,
  _stopTyping,
  _ratingTaskProfessionalRequest
}) => {
  const [messageText, setMessage] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [stopTypingTimeout, setStopTypingTimeout] = useState(undefined);
  const [hireModalIsOpen, setHireModalIsOpen] = useState(false);
  const [detailModalIsOpen, setDetailModalIsOpen] = useState(false);
  const [ratingDetailModalIsOpen, setRatingDetailModalIsOpen] = useState(false);
  const [modalProps, setModalProps] = useState({});

  const { user } = triiderUser;
  const { userTyping, messages = [] } = chat || {};
  const { chat_id, user_id: pro_id } = taskQuoteProDetail;
  const newAmountReason = taskQuoteProDetail.new_amount_comment || taskQuoteProDetail.new_amount_reason;
  const hasNewAmountComment = !!newAmountReason;

  const scrollChatToBottom = () => {
    const objDiv = viewRef.current;
    objDiv.scrollTop = objDiv.scrollHeight;
  };

  useEffect(() => {
    scrollChatToBottom();
    const unreadMessages = messages.filter(m => !m.is_read && m.user_id === pro_id);
    if (unreadMessages.length > 0) {
      _readMessages({ messages: unreadMessages, chat_id });
    }
  }, [messages, userTyping]);

  const userNotTyping = () => {
    // If the user was typing, but now the input is empty,
    // it means they've deleted everything and that triggered
    // an onChange event.  For this, we state they have stopped typing
    setIsTyping(false);
    _stopTyping(chat_id);
    // Stop the timeout, if there is one running
    if (stopTypingTimeout) {
      clearTimeout(stopTypingTimeout);
      setStopTypingTimeout(undefined);
    }
  };

  const send = (e) => {
    e.preventDefault();
    if (messageText) {
      setMessage('');
      setIsTyping(false);
      userNotTyping();

      const text = hidePhoneNumber(messageText);
      const isBlocked = hasBlockedContent(messageText);

      const messagesList = [];

      const message = {
        chat_id,
        text,
        message: text,
        is_read: false,
        is_system: false,
        system_key: null,
      };

      if (isBlocked) {
        const messageBlocked = {
          chat_id,
          text: 'conteudo bloqueado',
          message: 'conteudo bloqueado',
          time: new Date(),
          day: moment()
            .startOf('day')
            .format(),
          is_read: false,
          is_system: true,
          system_key: 'blocked',
        };

        messagesList.push(messageBlocked);
      }

      messagesList.push(message);

      _sendMessage(messagesList);
    }
  };

  const resetStopTypingTimeout = () => {
    if (stopTypingTimeout) {
      clearTimeout(stopTypingTimeout);
    }
    const stop = setTimeout(() => {
      setStopTypingTimeout(undefined);
      _stopTyping(chat_id);
    }, 5000);

    setStopTypingTimeout(stop);
  };

  const handleUserTyping = ({ target: { value } }) => {
    setMessage(value);
    const isInputEmpty = value.length === 0;
    // If the input isn't empty, and isTyping is false, update the state
    if (isInputEmpty === false) {
      // If the user wasn't typing before, and now the event has fired,
      // it means they are now typing
      if (isTyping === false) {
        setIsTyping(true);
        _startTyping(chat_id);
        // Start a 3 second countdown to see if they type within that window
        resetStopTypingTimeout();
      } else {
        // If the user typed another character, reset the timeout
        resetStopTypingTimeout();
      }
    } else if (isTyping === true) {
      userNotTyping();
    }
  };

  const onClickMessage = (system_key) => {
    const defaultProps = {
      isOpen: true,
      toggle: () => setModalProps({}),
    };
    switch (system_key) {
      case 'blocked':
        setModalProps({
          ...defaultProps,
          width: '430px',
          title: 'Bloqueamos essa mensagem',
          children: <BlockedModal close={defaultProps.toggle} />,
          padding: '35px 50px',
        });
        break;
      case 'quote_charged_new':
        setModalProps({
          ...defaultProps,
          width: '600px',
          title: 'ALTERAÇÃO DE VALOR',
          children: <NewAmountModal reason={newAmountReason} />,
          padding: '35px 50px',
        });
        break;
      default:
        break;
    }
  };

  const groupedMessages = _.groupBy(messages, msg => moment(msg.time).format('DD/MMMM/YYYY'));
  const today = moment().format('DD/MMMM/YYYY');
  const yesterday = moment().subtract(1, 'day').format('DD/MMMM/YYYY');

  const getDate = (date) => {
    if (date === today) return 'Hoje';
    if (date === yesterday) return 'Ontem';

    return date.replace(/\//g, ' de ');
  };

  const sendRating = feedback => {
    _ratingTaskProfessionalRequest({ task_id: taskDetail.id, feedback });
  };

  return (
    <ChatColumnCard>
      <Modal
        isOpen={modalProps.isOpen}
        toggle={modalProps.toggle}
        title={modalProps.title}
        width={modalProps.width}
        padding={modalProps.padding}
      >
        {modalProps.children}
      </Modal>
      <TopBar>
        {/* {taskDetail.status === 'open' && !taskQuoteProDetail.approved && !taskDetail.from_tenant && !taskQuoteProDetail.selected && (
          <Button onClick={() => setHireModalIsOpen(!hireModalIsOpen)}>
            <Icon src={hireChatIcon} alt="Hire Chat Icon" />
            <span>Contratar Profissional</span>
          </Button>
        )} */}
        {taskDetail.status === 'paid' && (
          <Button onClick={() => setRatingDetailModalIsOpen(!ratingDetailModalIsOpen)}>
            <Icon src={starIcon} alt="Star Icon" />
            <span>Avaliar profissional</span>
          </Button>
        )}
        <Button onClick={() => setDetailModalIsOpen(!detailModalIsOpen)}>
          <Icon src={detailsChatIcon} alt="Details Chat Icon" />
          <span>Detalhes do Pedido</span>
        </Button>
      </TopBar>
      <MessagesArea>
        <MessageList ref={viewRef}>
          {Object.entries(groupedMessages).map(([date, msgs]) =>
          (
            <Fragment key={`date-${date}`}>
              <Date>{getDate(date)}</Date>
              {msgs.map((m, i) => {
                const isUser = user.id === m.user_id;
                const isCompany = pro_id !== m.user_id;
                return (
                  <Message
                    onClick={onClickMessage}
                    key={`message-${user.id}-${m.id}-${i}`}
                    message={m}
                    isUser={isUser}
                    isCompany={isCompany}
                    hasNewChargedComment={hasNewAmountComment}
                    setHireModalIsOpen={setHireModalIsOpen}
                    messages={msgs}
                  />
                );
              })}
            </Fragment>
          ))}
        </MessageList>
        {userTyping && (
          <TypingIndicator>
            <span />
            <span />
            <span />
          </TypingIndicator>
        )}
      </MessagesArea>
      <SendBar onSubmit={send}>
        <InputMessage value={messageText} onChange={handleUserTyping} />
        <SendButton active={!!messageText} type="submit">
          <Icon src={paperAirplaneIcon} alt="Paper Airplane Icon" />
        </SendButton>
      </SendBar>

      <HireModal
        hireModalIsOpen={hireModalIsOpen}
        setHireModalIsOpen={setHireModalIsOpen}
      />

      <DetailsModal
        detailModalIsOpen={detailModalIsOpen}
        setDetailModalIsOpen={setDetailModalIsOpen}
      />

      <RatingsModal
        isOpen={ratingDetailModalIsOpen && taskDetail.status !== 'done'}
        close={() => setRatingDetailModalIsOpen(false)}
        onFinish={sendRating}
      />

    </ChatColumnCard>
  );
};

const mapStateToProps = state => {
  const { taskQuoteProDetail, taskDetail, ratingTaskProfessionalSuccess } = state.task;
  const { chat_id } = taskQuoteProDetail;
  return {
    taskQuoteProDetail,
    taskDetail,
    ratingTaskProfessionalSuccess,
    chat: state.chat.chats.find(c => c.chat_id === chat_id),
    triiderUser: state.auth.triiderUser,
  };
};

const mapDispatchToProps = {
  _readMessages: ChatCreators.readMessages,
  _sendMessage: ChatCreators.sendMessage,
  _startTyping: ChatCreators.startTyping,
  _stopTyping: ChatCreators.stopTyping,
  _ratingTaskProfessionalRequest: TaskCreators.ratingTaskProfessionalRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChatColumn);
